<template>
    <v-tab-item :value="WMDS.value">
        <section class="sub-section">
            <v-container>
                <v-row class="mb-40 mb-lg-86">
                    <v-col cols="12" lg="6" class="mb-20 mb-lg-0">
                        <div class="w-100 h-100 radius-lg bg-grey px-16 d-flex align-center">
                            <v-img class="d-block mx-auto" max-width="582" src="/images/sub/products/wmds/s1-img1-en.png"></v-img>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="pl-xl-40">
                            <h3 class="tit--lg font-weight-bold mb-32 mb-lg-58">
                                <!-- What is a website (homepage) where malicious code is distributed and transited? -->
                                {{ settings.product.wmds.first }}
                            </h3>
                            <p class="page-text-lg color-point font-weight-700 mb-2 mb-lg-8">
                                Features 1.
                            </p>
                            <p class="page-text-lg color-grey-57 mb-20 mb-lg-46">
                                This is a very dangerous website that can be infected with malicious code when users access it through a browser.
                            </p>
                            <p class="page-text-lg color-point font-weight-700 mb-2 mb-lg-8">
                                Feature 2.
                            </p>
                            <p class="page-text-lg color-grey-57 mb-10 mb-lg-20">
                                Malicious code such as ransomware, which has recently become a social issue, is also infected by accessing such websites.
                            </p>
                        </div>
                    </v-col>
                </v-row>
                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    What if malicious code is distributed or passed through on our website?
                </h4>
                <v-row class="mx-lg-n44">
                    <v-col cols="12" lg="4" class="px-lg-44 mb-20 mb-lg-0">
                        <div class="process-3dep1 w-100 h-100">
                            <div class="radius-lg bg-grey h-100">
                                <v-img class="d-block w-100" max-width="1024" src="/images/sub/products/wmds/s1-img2-1.png"></v-img>
                                <div class="pa-16 py-md-46">
                                    <p class="page-text-sm color-grey-49 text-center">
                                        At  the moment the website is hacked, it is the victim’s At  the moment <span class="font-weight-bold color-point">of distribution or transit,</span> you become <span class="font-weight-bold color-point">the perpetrator.</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4" class="px-lg-44 mb-20 mb-lg-0">
                        <div class="process-3dep2 w-100 h-100">
                            <div class="radius-lg bg-grey h-100">
                                <v-img class="d-block w-100" max-width="1024" src="/images/sub/products/wmds/s1-img2-2.png"></v-img>
                                <div class="pa-16 py-md-46">
                                    <p class="page-text-sm color-grey-49 text-center">
                                        Businesses subject to the Information and Communications Network Act may be subject to government crackdowns, <span class="font-weight-bold color-point">fines for negligence, and surcharges</span> on the grounds that the security measures required by the law are insufficient.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4" class="px-lg-44">
                        <div class="process-3dep3 w-100 h-100">
                            <div class="radius-lg bg-grey h-100 process-3dep3">
                                <v-img class="d-block w-100" max-width="1024" src="/images/sub/products/wmds/s1-img2-3.png"></v-img>
                                <div class="pa-16 py-md-46">
                                    <p class="page-text-sm color-grey-49 text-center">
                                        It could also be embroiled in <span class="font-weight-bold color-point">a class action dispute</span> from users infected with malware, severely damaging the image of institutions and businesses..
                                    </p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="sub-section bg-grey">
            <v-container>
                <h3 class="tit--lg text-center mb-lg-22">
                    <!-- F1-WMDS <br>
                    Web Malware Detection System란? -->
                    {{ settings.product.wmds.second }}
                </h3>
                <v-img class="d-block mx-auto mb-28 mb-lg-50" max-width="820" src="/images/sub/products/wmds/s2-img1-en.png"></v-img>

                <div class="bg-white border-light radius-md">
                    <div class="border-bottom border-color-light pa-16 pa-md-0">
                        <v-img class="tb mx-auto" max-width="1200" src="/images/sub/products/wmds/s2-img2-en.png"></v-img>
                        <v-img class="mo mx-auto" max-width="561" src="/images/sub/products/wmds/s2-img2-mo-en.png"></v-img>
                    </div>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" class="border-right border-color-light d-flex align-center pa-16 px-md-50 py-lg-20">
                            <v-img class="d-block mr-10 mr-lg-20" max-width="90" src="/images/sub/products/wmds/s2-icon1-1.png"></v-img>
                            <div>
                                <p class="page-text-sm color-grey-49 line-height-12">
                                    <span class="font-weight-bold d-inline-block mb-2 mb-lg-4">Hacker</span> <br>
                                    Malicious code injection using security vulnerabilities as an intentional attack
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex align-center pa-16 px-md-50 py-lg-20">
                            <v-img class="d-block mr-10 mr-lg-20" max-width="90" src="/images/sub/products/wmds/s2-icon1-2.png"></v-img>
                            <div>
                                <p class="page-text-sm color-grey-49 line-height-12">
                                    <span class="font-weight-bold d-inline-block mb-2 mb-lg-4">Co-partner</span> <br>
                                    Uploaded content with malicious code already inserted into content produced by partner companies due to unintentional attack
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- Optimized for proactive detection of website malware distribution codes. -->
                    {{ settings.product.wmds.third }}
                </h3>

                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    Key Features Summary
                </h4>

                <v-row class="mb-40 mb-lg-86">
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                01
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                Maintain web service stability
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                365days and 24 hours 
                                detection  of malware 
                                distribution and insertion
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                02
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                Easy registration
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                It can be used by registering 
                                only the domain as a non-agent
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                03
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                Operation Convenience
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                Provides a convenient operating
                                environment such as setting 
                                the website depth and the number 
                                of pages to be inspected
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                04
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                Obfuscation processin
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                Hidden distribution code detection using Javascript obfuscation processing technology
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                05
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                External link tracking
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                Recognizes and tracks external 
                                links and traces the route 
                                to the distribution site.
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                06
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                Latest DB pattern 
                                applied
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                Provide up-to-date DB patterns
                                of malicious code distribution
                                sites/passages 
                                (Korea Internet & Security 
                                Agency, own analysis staff, etc.)
                            </p>
                        </div>
                    </v-col>
                </v-row>

                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    Main target customers
                </h4>

                <v-row no-gutters class="radius-lg">
                    <v-col cols="12" lg="6" class="pa-16 py-lg-48 bg-img d-lg-flex align-center justify-center" style="background-image: url(/images/sub/products/wmds/s3-img1-1.png);">
                        <div style="w-auto">
                            <h6 class="page-text-lg color-white mb-4 mb-lg-32">
                                Protecting visiting customers and <br class="d-none d-lg-block">
                                keep their trust on your website
                            </h6>
                            <p class="page-text-sm color-white font-weight-bold">
                                Public institutions & organizations
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6" class="pa-16 py-lg-48 pl-lg-60 bg-img" style="background-image: url(/images/sub/products/wmds/s3-img1-2.png);">
                        <h6 class="page-text-lg color-gery-57 mb-4 mb-lg-8">
                            Large-scale website security management organization
                        </h6>
                        <p class="page-text-sm color-point font-weight-bold">
                            Security control companies, web hosting companies, <br class="d-none d-lg-block">
                            IDC, Group/subsidiary security management <br class="d-none d-lg-block">
                            organization, CERT organization, etc.
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="sub-section bg-grey">
            <v-container>
                <div class="section-title mb-32 mb-lg-56">
                    <h3 class="tit--lg text-center mb-30 mb-lg-44">
                        <!-- Introducing F1-WMDS (Web Malware Detection System) solution -->
                        {{ settings.product.wmds.fourth }}
                    </h3>
                    <p class="page-text-lg color-grey-57 text-center">
                        It is a system for periodically checking whether a code that distributes malware is inserted into a website, detects malicious code before it is distributed, and notifies the system administrator or control system to take action.
                    </p>
                </div>
                <div class="s2-box border-light bg-white">
                    <v-row no-gutters>
                        <v-col cols="12" lg="6" class="border-right border-color-light">
                            <p class="py-10 page-text-sm font-weight-bold color-point text-center border-bottom border-color-light">
                                Intrusion incident detection/
                                reinforcement response
                            </p>
                            <div class="pa-16 py-md-24">
                                <p class="color-grey-49 page-text-sm text-center">
                                   Preventing and responding to accidents through periodic inspection of new/changed web service contents
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <p class="py-10 page-text-sm font-weight-bold color-point text-center border-bottom border-color-light">
                                Ensuring web service continuity
                            </p>
                            <div class="pa-16 py-md-24">
                                <p class="color-grey-49 page-text-sm text-center">
                                    Ensure continuity of web service by not affecting non-agent implementation and network configuration
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                    <p class="w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14 border-top border-bottom border-color-light">
                        Dedicated detection solution to respond to web-based malware distribution attacks
                    </p>
                    <v-row no-gutters>
                        <v-col cols="12" lg="4" class="border-right border-color-light">
                            <div class="bg-grey py-10">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="pa-16 py-md-50 border-top border-color-light">
                                <v-img class="mx-auto d-block mb-8 mb-lg-20" max-width="69" src="/images/sub/products/wmds/s4-icon1-1.png"></v-img>
                                <p class="page-text-lg line-height-1 font-weight-bold text-center">Easy to use</p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="4" class="border-right border-color-light">
                            <div class="bg-grey py-10 d-none d-lg-block">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="pa-16 py-md-50 border-top border-color-light">
                                <v-img class="mx-auto d-block mb-8 mb-lg-20" max-width="69" src="/images/sub/products/wmds/s4-icon1-2.png"></v-img>
                                <p class="page-text-lg line-height-1 font-weight-bold text-center">Web server security enhancement</p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <div class="bg-grey py-10 d-none d-lg-block">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="pa-16 py-md-50 border-top border-color-light">
                                <v-img class="mx-auto d-block mb-8 mb-lg-20" max-width="69" src="/images/sub/products/wmds/s4-icon1-3.png"></v-img>
                                <p class="page-text-lg line-height-1 font-weight-bold text-center">Easy to operate</p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
        <section class="sub-section">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- Optimized to detect incidents caused by website malware distribution codes. -->
                    {{ settings.product.wmds.fifth }}
                </h3>
                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    WMDS Key features
                </h4>
                <div class="radius-lg bg-grey mb-40 mb-lg-80 tb">
                     <v-img class="w-100 d-block" max-width="1200" src="/images/sub/products/wmds/s5-img1-en.png"></v-img>
                </div>
                <div class="mb-40 mo">
                    <v-img class="mx-auto d-block" max-width="400" src="/images/sub/products/wmds/s5-img1-mo-en.png"></v-img>
                </div>
                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    Expected effects of F1-WMDS
                </h4>
                <v-img class="w-100 d-block" max-width="1200" src="/images/sub/products/wmds/s5-img2-en.png"></v-img>
            </v-container>
        </section>
    </v-tab-item>
</template>

<script>
import { PRIVATE_SALES_EN_TABS } from "@/assets/variables";
const { WMDS } = PRIVATE_SALES_EN_TABS;
import api from "@/api"
export default {
    data() {
        return {
            WMDS,
            settings: null,
            filter: {
                code: "en"
            }
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            const { settings } = await api.v1.boards.settings.get({
                headers: this.filter
            })
            this.settings = settings[0]
        }
    }
};
</script>

<style scoped>
.process-3dep1, 
.process-3dep2{
    position: relative;
}

.process-3dep1::after, 
.process-3dep2::after{
    content: "";
    display: block;
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 4px solid #f4f7fb;
    background-color: #e4eefc;
    background-image: url(/images/sub/products/wmds/process-arrow.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    top: 50%;
    right: -72px;
    transform: translate(0, -50%);
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .card{
        min-height: 246px;
    }
}
@media (min-width:1200px){
}

</style>
